import React from "react";

class OptionalBillingInfo extends React.Component {
    state = {
        showBillingInfoInput: false
    };

    handleClick = e => {
        e.preventDefault();
        this.setState({ showBillingInfoInput: true });
    };

    render() {
        if (this.state.showBillingInfoInput) {
            return (
                <li className="optional-billing expand-to-visible">
                    {this.props.children}
                </li>
            );
        }

        return (
            <li>
                <a
                    href="#"
                    className="show-optional-billing text-link"
                    onClick={this.handleClick}
                >
                    Add optional billing information
                </a>
            </li>
        );
    }
}

export default OptionalBillingInfo;
